import { createFileRoute } from '@tanstack/react-router';
import SharedLinkLandingPage from 'src/SharedLinkPage/SharedLinkLandingPage';

export const Route = createFileRoute('/library/shared/$linkId/media-page/$clipId')({
  component: () => <SharedLinkLandingPage mediaPage={true} />,
});
